export default __webpack_public_path__ + "static/media/CENTRAL_INDEX.af762a09.png";